<template>
  <div>
    <form-item label='Bank Name'>
      <template v-slot>
        <Input
          v-model="bank"
          placeholder="Bank Name"
          :error="($v.bank.$dirty && !$v.bank.required)"
        />
        <div class="flex flex-col pt-2">
          <text-error
            v-if="$v.bank.$dirty && !$v.bank.required"
            text="Bank Name must be filled."
          />
        </div>
      </template>
    </form-item>
    <form-item label='Account Name'>
      <template v-slot>
        <Input
          v-model="account_name"
          placeholder="Account Name"
          :error="$v.account_name.$dirty && !$v.account_name.required"
        />
        <div class="flex flex-col pt-2">
          <text-error
            v-if="$v.account_name.$dirty && !$v.account_name.required"
            text="Account Name must be filled."
          />
        </div>
      </template>
    </form-item>
    <form-item label='Account Number'>
      <template v-slot>
        <Input
          v-model="account_number"
          placeholder="Account Number"
          :error="$v.account_number.$dirty && !$v.account_number.required"
        />
        <div class="flex flex-col pt-2">
          <text-error
            v-if="$v.account_number.$dirty && !$v.account_number.required"
            text="Account Number must be filled."
          />
        </div>
      </template>
    </form-item>
    <form-item label='Swift Code'>
      <template v-slot>
        <Input
          v-model="swift_code"
          placeholder="Swift Code"
          :error="$v.swift_code.$dirty && !$v.swift_code.required"
        />
        <div class="flex flex-col pt-2">
          <text-error
            v-if="$v.swift_code.$dirty && !$v.swift_code.required"
            text="Swift Code must be filled."
          />
        </div>
      </template>
    </form-item>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email, maxLength, numeric } from 'vuelidate/lib/validators';
import { Button, FormItem, Input, Select, TextArea, TextError } from '@/components/Layout/Form';

export default {
  name: 'Step2',
  mixins: [validationMixin],
  data: () => ({
    bank: '',
    account_name: '',
    account_number: '',
    swift_code: '',
    showError: false,
  }),
  validations() {
    let rules = {
      bank: {},
      account_number: {},
      account_name: {},
      swift_code: {},
    };
    if (this.bank !== '' || this.account_number !== '' || this.account_name !== '' || this.swift_code !== '') {
      console.log('kosong ko');
      rules = {
        bank: {
          required,
        },
        account_number: {
          required, numeric,
        },
        account_name: {
          required,
        },
        swift_code: {
          required,
        },
      };
    }

    return rules;
  },
  methods: {
    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      if ((this.bank !== '' || this.account_number !== '' || this.account_name !== '' || this.swift_code !== '') && !isValid) {
        this.showError = true;
        return false;
      }
      this.showError = false;
      this.$emit('on-validate', this.$data, isValid);
      return isValid;
    },
  },
  components:{
    FormItem,
    Input,
    TextArea,
    Button,
    TextError,
    Select,
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ArtistContent/Step2.vue